module.exports = __webpack_public_path__ + "static/media/ms-white-logo.26090c57.svg";